/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalAuthSubmissionMode = {
    Pending: 'pending',
    Manual: 'manual',
    Automated: 'automated',
    HospitalInitiated: 'hospital_initiated',
    Efax: 'efax'
} as const;
export type PalAuthSubmissionMode = typeof PalAuthSubmissionMode[keyof typeof PalAuthSubmissionMode];


export function PalAuthSubmissionModeFromJSON(json: any): PalAuthSubmissionMode {
    return PalAuthSubmissionModeFromJSONTyped(json, false);
}

export function PalAuthSubmissionModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMode {
    return json as PalAuthSubmissionMode;
}

export function PalAuthSubmissionModeToJSON(value?: PalAuthSubmissionMode | null): any {
    return value as any;
}

